import { useEffect, useState } from 'react';
import { FileText } from 'lucide-react';
import { updateProject } from '@/lib/api';
import type { Project } from '@/lib/types';

interface Props {
  project: Project;
  onChanged: () => void;
}

export function TranscriptCard({ project, onChanged }: Props) {
  const [text, setText] = useState(project.description ?? '');
  const [saving, setSaving] = useState(false);
  const [open, setOpen] = useState(Boolean(project.description));

  useEffect(() => {
    setText(project.description ?? '');
  }, [project.id, project.description]);

  useEffect(() => {
    if (text === (project.description ?? '')) return;
    setSaving(true);
    const t = setTimeout(() => {
      updateProject(project.id, { description: text || null })
        .then(() => onChanged())
        .finally(() => setSaving(false));
    }, 700);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text]);

  return (
    <div className="rounded-xl border border-bmade-200 bg-white p-4 dark:border-bmade-800 dark:bg-bmade-900/40">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="flex w-full items-center justify-between text-xs font-semibold uppercase tracking-wider text-bmade-700 dark:text-bmade-300"
      >
        <span className="inline-flex items-center gap-2">
          <FileText className="h-3 w-3" />
          Gespreks-samenvatting
        </span>
        <span className="text-[10px] text-bmade-500">
          {saving ? 'opslaan...' : open ? 'verbergen' : text ? 'bekijk' : 'leeg, klik om in te vullen'}
        </span>
      </button>
      {open && (
        <textarea
          rows={4}
          value={text}
          onChange={(e) => setText(e.target.value)}
          placeholder="Plak hier de samenvatting van het inspiratie-gesprek met de klant. Tool gebruikt dit als context op de klant-PDF."
          className="mt-3 w-full rounded-md border border-bmade-200 bg-white px-3 py-2 text-sm leading-relaxed text-bmade-950 outline-none focus:border-accent-500 dark:border-bmade-700 dark:bg-bmade-950/60 dark:text-white"
        />
      )}
    </div>
  );
}
